module.exports = __webpack_public_path__ + "static/media/Paraphilia_FB Banner.44a83a4e.jpg";